export * from './click-outside.directive';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/directives/index.ts